import * as IntegrationActions from "src/app/store/integration/actions";
import * as FromIntegration from "src/app/store/integration/selectors";
import { ChangeDetectionStrategy, Component } from "@angular/core";
import { IntegrationDto } from "@api";
import { AlertController } from "@ionic/angular";
import { Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import { Observable } from "rxjs";
import { AppRoutes } from "src/app/constants";
import { RootState } from "src/app/store";

@Component({
  selector: "app-integrations",
  templateUrl: "./integrations.page.html",
  styleUrls: ["./integrations.page.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IntegrationsPage {
  public routes: typeof AppRoutes = AppRoutes;
  public integrations: Observable<IntegrationDto[]> = this.store.select(FromIntegration.selectIntegrations);
  public breadcrumbs: { name: string; link?: string }[] = [
    { name: this.i18n.instant("DASHBOARD.BREADCRUMB_NAME"), link: `/${this.routes.home}` },
    { name: this.i18n.instant("INTEGRATIONS.BREADCRUMB_NAME"), link: `/${this.routes.integrations}` },
  ];

  constructor(private store: Store<RootState>, private i18n: TranslateService, private alertController: AlertController) {}

  public async suggestIntegration(): Promise<void> {
    const alert = await this.alertController.create({
      header: this.i18n.instant("INTEGRATIONS.SUGGEST_HEADER"),
      message: this.i18n.instant("INTEGRATIONS.SUGGEST_MESSAGE"),
      backdropDismiss: false,
      keyboardClose: false,
      inputs: [{ type: "textarea", name: "suggestion" }],
      buttons: [
        { text: this.i18n.instant("BUTTONS.CANCEL"), role: "destructive" },
        { text: this.i18n.instant("BUTTONS.OK"), handler: this.handleSuggestion.bind(this) },
      ],
    });

    await alert.present();
  }

  protected ionViewDidEnter(): void {
    this.store.dispatch(IntegrationActions.getIntegrations());
  }

  private handleSuggestion({ suggestion }: any): void {
    if (suggestion) this.store.dispatch(IntegrationActions.sendSuggestion({ suggestIntegrationDto: { suggestion } }));
  }
}
